import { EAppVariant } from "dto/EAppVariant";
import { EAppExtension } from "dto/EAppExtension";

/** Tryb pracy zakładki Plany. */
export enum ESubscriptionMode {
  /** Subskrypcja prywatna — użytkownik zarządza wyłącznie własnym pakietem. */
  Private = 0,
  /** Subskrypcja zespołowa — właściciel/administrator konfiguruje członków. */
  Team = 1,
}

export interface ISubscriptionMember {
  UserId: string;
  /** Profil, którego dotyczy subskrypcja (zespołowy lub bazowy IsBase). */
  ProfileId?: string;
  Label: string;
  /** Status członka zespołu (kropka na awatarze, sortowanie). 0 dla trybu prywatnego. */
  Status: number;
  IsMe: boolean;
  /** Czy bieżący użytkownik może edytować subskrypcję tego członka. */
  CanEdit: boolean;

  Variant: EAppVariant;
  Extensions: EAppExtension[];
  /** Pełna opłata miesięczna konfiguracji (zł, bez proporcji). */
  MonthlyCost: number;
  /** Pojemność dysku wynikająca z pakietu (bajty). */
  DiskQuotaBytes: number;

  /**
   * Data, do której obowiązuje bieżąca (opłacona) konfiguracja, gdy zaplanowano zmianę
   * z końcem okresu (downgrade pakietu / usunięcie modułu). null = brak zaplanowanej zmiany.
   */
  ActiveUntil?: string | null;
  /** Pakiet obowiązujący od kolejnego okresu (gdy zaplanowano zmianę). null = bez zmiany. */
  ScheduledVariant?: EAppVariant | null;
  /** Moduły obowiązujące od kolejnego okresu (gdy zaplanowano zmianę). null = bez zmiany. */
  ScheduledExtensions?: EAppExtension[] | null;
  /** Pełna opłata miesięczna od kolejnego okresu (zł). null = bez zmiany. */
  ScheduledMonthlyCost?: number | null;
}

export interface ISubscriptionsView {
  Mode: ESubscriptionMode;
  /** Czy bieżący użytkownik może zarządzać tym widokiem (właściciel/admin zespołu lub właściciel prywatny). */
  CanManage: boolean;
  /** Ustawione tylko w trybie zespołowym. */
  WorkspaceId?: string;
  Members: ISubscriptionMember[];
}

/** Pojedyncza zmiana w batchu zespołu. */
export interface IUpdateSubscriptionsBatchItem {
  MemberUserId: string;
  Variant: EAppVariant;
  Extensions: EAppExtension[];
}

/** Batch zmian subskrypcji zespołu (jeden zapis → jedna płatność). */
export interface IUpdateSubscriptionsBatchRequest {
  WorkspaceId?: string | null;
  Changes: IUpdateSubscriptionsBatchItem[];
}

/** Wynik zmiany subskrypcji — sygnalizuje, czy trzeba dodać kartę, by dokończyć płatność. */
export interface ISubscriptionChangeResult {
  RequiresPaymentMethod: boolean;
}

/** Żądanie aktualizacji subskrypcji — odpowiednik UpdateSubscriptionRequest w BE. */
export interface IUpdateSubscriptionRequest {
  /** null = subskrypcja prywatna; ustawione = zespół (wymaga uprawnień admina). */
  WorkspaceId?: string | null;
  /** Dla zespołu: którego członka dotyczy. null = bieżący użytkownik. */
  MemberUserId?: string | null;
  Variant: EAppVariant;
  Extensions: EAppExtension[];
}
